import React from 'react';
import axios from 'axios';
import {Bar} from 'react-chartjs-2';

const url = 'https://masteryrace-api.vercel.app/api/summoner/graphData';
var original = [];

class Graph extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : false,
            apiResult: "",
            item: [],
            sort: "",
            chartData : {
                labels: [],
                datasets: [
                  {
                    label:'Points',
                    data: [],
                    backgroundColor:[],
                    borderColor: [],
                  }
                ]
            }
        };
        this.chartReference = React.createRef();
        this.fillChartData = this.fillChartData.bind(this);
        this.sortAscending = this.sortAscending.bind(this);
        this.sortDescending = this.sortDescending.bind(this);
        this.sortNone = this.sortNone.bind(this);
    }

    async componentDidMount() {
      this.setState({ isLoaded: false });
      try{
        const response = await axios.get(url);
        this.setState({
          isLoaded: true,
          item: response.data
        });
        this.fillChartData();
        this.props.setLoaded1(true);
      }catch(err){
        console.log(err);
      }
    }

    componentDidUpdate(prevProps) {
      if(prevProps !== this.props) {
        this.setState({
          sort: this.props.sort
        });
        if (this.props.sort === "HightoLow"){
          this.sortDescending();
        }else if(this.props.sort === "LowtoHigh"){
          this.sortAscending();
        }else if (this.props.sort === "None"){
          this.sortNone();
        }
      }
    }

    sortNone = () => {
      let barChart = this.reference.chartInstance;
      var pointsNone = [...original];
      this.state.chartData.labels = [];
      this.state.chartData.datasets[0].data = [];
      Object.keys(pointsNone).forEach(key => this.state.chartData.datasets[0].data.push(pointsNone[key].points));
      Object.keys(pointsNone).forEach(key => this.state.chartData.labels.push(pointsNone[key].summ));
      barChart.update();
    }

    sortAscending = () => {
      let barChart = this.reference.chartInstance;
      var pointsAscending = [...original];
      pointsAscending.sort(function (a, b) {
        return a.points - b.points;
      });
      this.state.chartData.labels = [];
      this.state.chartData.datasets[0].data = [];
      Object.keys(pointsAscending).forEach(key => this.state.chartData.datasets[0].data.push(pointsAscending[key].points));
      Object.keys(pointsAscending).forEach(key => this.state.chartData.labels.push(pointsAscending[key].summ));
      barChart.update();
    }

    sortDescending = () => {
      let barChart = this.reference.chartInstance;
      var pointsDescending = [...original];
      pointsDescending.sort(function (a, b) {
        return b.points - a.points;
      });
      this.state.chartData.labels = [];
      this.state.chartData.datasets[0].data = [];
      Object.keys(pointsDescending).forEach(key => this.state.chartData.datasets[0].data.push(pointsDescending[key].points));
      Object.keys(pointsDescending).forEach(key => this.state.chartData.labels.push(pointsDescending[key].summ));
      barChart.update();
    }
    
    async fillChartData(){
      let barChart = this.reference.chartInstance;
      original = [];
      var canvas = document.getElementById("barGraph");
      var ctx = canvas.getContext("2d");
      var gradient = ctx.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(0, 'rgba(52, 152, 219, 1)');   
      gradient.addColorStop(1, 'rgba(214, 234, 248, 1)');
      Object.keys(this.state.item.data).forEach(
        key => {
          if (this.state.item.data[key].championPoints === undefined){
            this.state.item.data[key].championPoints = 0;
          }
          this.state.chartData.datasets[0].data.push(this.state.item.data[key].championPoints);
        })
      Object.keys(this.state.item.data).forEach(key => this.state.chartData.labels.push(this.state.item.data[key].summ));
      Object.keys(this.state.item.data).forEach(key => original.push({summ: this.state.item.data[key].summ, points: this.state.item.data[key].championPoints}));
      for (var i = 0; i<original.length; i++){
        // this.state.chartData.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
        this.state.chartData.datasets[0].backgroundColor.push(gradient);
      } 
      barChart.update();
    }

    render(){
      //if is loaded = false, render a loading screen
      if (this.state.isLoaded === false){
        return null;
      }
      return(
          <div className = "chart">
              <Bar 
                  id = 'barGraph'
                  ref = {(reference) => this.reference = reference}
                  data = {this.state.chartData}
                  options = {
                    {
                    tooltips: {
                      callbacks: {
                        label: function(tooltipItem, data) {
                          var value = data.datasets[0].data[tooltipItem.index];
                          value = value.toString();
                          value = value.split(/(?=(?:...)*$)/);
                          value = value.join(',');
                          value = value.concat(" points")
                          return value;
                        }
                      } // end callbacks:
                    }, //end tooltips
                    title:{
                        display: false,
                        text: this.state.item.selectedChamp,
                        fontSize:20
                      },
                      legend:{
                        display:true,
                        position:'right'
                      },
                    scales: {
                      xAxes: [{
                        barPercentage: 0.5,
                        gridLines: {
                          color: "rgba(0, 0, 0, 0)",
                        }
                      }],
                      yAxes: [{
                        gridLines: {
                          color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                          beginAtZero: true,
                          userCallback: function(value, index, values) {
                            value = value.toString();
                            value = value.split(/(?=(?:...)*$)/);
                            value = value.join(',');
                            return value;
                          }
                        }
                      }]
                    }
                  }
                }
              />
          </div>
      ) 
    }

}export default Graph;